import PageModel from '@/models/pageModel';

export class PatientsSubscriptions extends PageModel {
    static moduleName = 'patientsSubscriptions';
    static moduleEntityName = 'patientsSubscriptionEntity';
    static listTitle = 'Подписки';
    static editTitle = 'Изменение данных о подписке';
    static apiPrefix = 'subscriptions';
    static entityName = 'Подписка';
}